import { getVehicleTypeList } from '@/api/waybill'
const state = () => ({
  // 准驾车型
  driverClassList: [
    {
      value: 1,
      label: 'A1'
    },
    {
      value: 2,
      label: 'A2'
    },
    {
      value: 3,
      label: 'A3'
    },
    {
      value: 4,
      label: 'B1'
    },
    {
      value: 5,
      label: 'B2'
    },
    {
      value: 6,
      label: 'C1'
    },
    {
      value: 7,
      label: 'C2'
    },
    {
      value: 8,
      label: 'C3'
    },
    {
      value: 9,
      label: 'C4'
    },
    {
      value: 10,
      label: 'D'
    },
    {
      value: 11,
      label: 'E'
    },
    {
      value: 12,
      label: 'F'
    },
    {
      value: 13,
      label: 'M'
    },
    {
      value: 14,
      label: 'N'
    },
    {
      value: 15,
      label: 'P'
    }
  ],
  // 散货单货物类型
  cargoTypeClass: [
    {
      value: '0100',
      label: '煤炭及制品'
    },
    {
      value: '0200',
      label: '石油、天然气及制品'
    },
    {
      value: '0300',
      label: '金属矿石'
    },
    {
      value: '0400',
      label: '钢铁'
    },
    {
      value: '0500',
      label: '矿建材料'
    },
    {
      value: '0600',
      label: '水泥'
    },
    {
      value: '0700',
      label: '木材'
    },
    {
      value: '0800',
      label: '非金属矿石'
    },
    {
      value: '0900',
      label: '化肥及农药'
    },
    {
      value: '1000',
      label: '盐'
    },
    {
      value: '1100',
      label: '粮食'
    },
    {
      value: '1200',
      label: '机械、设备、电器'
    },
    {
      value: '1300',
      label: '轻工原料及制品'
    },
    {
      value: '1400',
      label: '有色金属'
    },
    {
      value: '1500',
      label: '轻工医药产品'
    },
    {
      value: '1601',
      label: '鲜活农产品'
    },
    {
      value: '1602',
      label: '冷藏冷冻货物'
    },
    {
      value: '1701',
      label: '商品汽车'
    },
    {
      value: '1702',
      label: '快递'
    },
    {
      value: '1700',
      label: '其他'
    }
  ],
  // 车辆类型
  vehicleTypeList: [],
  // 车辆审核状态
  vehicleStateList: [
    {
      value: 1,
      label: '待提交',
      type: 'primary'
    },
    {
      value: 2,
      label: '待审核',
      type: 'warning'
    },
    {
      value: 3,
      label: '审核通过',
      type: 'success'
    },
    {
      value: 10,
      label: '审核未通过',
      type: 'danger'
    }
  ],
  // 车辆长度
  vehicleLengthList: [
    {
      value: 6,
      label: '1.8米'
    },
    {
      value: 7,
      label: '2.7米'
    },
    {
      value: 8,
      label: '3.8米'
    },
    {
      value: 9,
      label: '4.2米'
    },
    {
      value: 10,
      label: '5米'
    },
    {
      value: 11,
      label: '6.2米'
    },
    {
      value: 2,
      label: '6.6米'
    },
    {
      value: 1,
      label: '6.8米'
    },
    {
      value: 12,
      label: '7.7米'
    },
    {
      value: 3,
      label: '7.8米'
    },
    {
      value: 13,
      label: '8.2米'
    },
    {
      value: 14,
      label: '8.7米'
    },
    {
      value: 4,
      label: '9.6米'
    },
    {
      value: 15,
      label: '11.7米'
    },
    {
      value: 16,
      label: '12.5米'
    },
    {
      value: 5,
      label: '13米'
    },
    {
      value: 17,
      label: '15米'
    },
    {
      value: 18,
      label: '16米'
    },
    {
      value: 19,
      label: '17.5米'
    }

  ],
  // 牌照类型
  vehicleLicenceTypeList: [
    {
      value: 1,
      label: '大型汽车号牌',
      status: 0
    },
    {
      value: 2,
      label: '小型汽车号牌',
      status: 0
    },
    {
      value: 3,
      label: '其他号牌',
      status: 0
    },
    {
      value: 4,
      label: '蓝色',
      status: 1
    },
    {
      value: 5,
      label: '黄色',
      status: 1
    },
    {
      value: 6,
      label: '白色',
      status: 1
    },
    {
      value: 7,
      label: '绿色',
      status: 1
    },
    {
      value: 8,
      label: '黑色',
      status: 1
    },
    {
      value: 9,
      label: '其他',
      status: 1
    },
    {
      value: 10,
      label: '农黄色',
      status: 1
    },
    {
      value: 11,
      label: '农绿色',
      status: 1
    },
    {
      value: 12,
      label: '黄绿色',
      status: 1
    },
    {
      value: 13,
      label: '渐变绿',
      status: 1
    }

  ],
  // 能源类型
  vehicleEnergyTypeList: [
    {
      value: 1,
      value2: 'A',
      label: '汽油'
    },
    {
      value: 2,
      value2: 'B',
      label: '柴油'
    },
    {
      value: 3,
      value2: 'C',
      label: '电'
    },
    {
      value: 4,
      value2: 'D',
      label: '混合油'
    },
    {
      value: 5,
      value2: 'E',
      label: '天然气'
    },
    {
      value: 6,
      value2: 'F',
      label: '液化石油气'
    },
    {
      value: 7,
      value2: 'L',
      label: '甲醇'
    },
    {
      value: 8,
      value2: 'M',
      label: '乙醇'
    },
    {
      value: 9,
      value2: 'N',
      label: '太阳能'
    },
    {
      value: 10,
      value2: 'O',
      label: '混合动力'
    },
    {
      value: 11,
      value2: 'Y',
      label: '无'
    },
    {
      value: 12,
      value2: 'Z',
      label: '其他'
    }
  ],
  // 车辆重量
  vehicleWeightList: [],
  // 运单价格单位
  cargoPriceUnit: [
    // {
    //   value: 1,
    //   label: '集装箱'
    // },
    // {
    //   value: 2,
    //   label: '件'
    // },
    {
      value: 3,
      label: '车'
    },
    {
      value: 4,
      label: '吨'
    },
    {
      value: 5,
      label: '立方米'
    }
  ],
  // 计划单状态
  planStatus: [
    {
      value: 1,
      label: '开启',
      type: 'success'
    },
    {
      value: 11,
      label: '关闭',
      type: 'danger'
    },
    {
      value: 99,
      label: '关闭',
      type: 'danger'
    }
  ],
  // 计划单匹配列表状态
  matchStatusList: [
    {
      value: 1,
      label: '匹配中',
      type: ''
    },
    {
      value: 2,
      label: '已同意',
      type: 'success'
    },
    {
      value: 11,
      label: '已拒绝',
      type: 'danger'
    },
    {
      value: 21,
      label: '已过期',
      type: 'danger'
    },
    {
      value: 99,
      label: '已取消',
      type: 'info'
    }
  ],
  // 订单状态
  orderStatusList: [
    {
      value: 1,
      label: '待接单',
      type: 'primary',
      effect: 'plain'
    },
    {
      value: 2,
      label: '待装车',
      type: 'warning',
      effect: 'plain'
    },
    {
      value: 3,
      label: '待卸车',
      type: 'danger',
      effect: 'plain'
    },
    {
      value: 4,
      label: '待确认',
      type: 'success',
      effect: 'plain'
    },
    {
      value: 5,
      label: '待经纪人确认',
      type: 'warning',
      effect: 'light'
    },
    {
      value: 6,
      label: '结算中',
      type: 'primary',
      effect: 'light'
    },
    {
      value: 9,
      label: '已完成',
      type: 'success',
      effect: 'light'
    },
    {
      value: 99,
      label: '已关闭',
      type: 'danger',
      effect: 'light'
    }
  ],
  payChannelList: [
    {
      value: 5,
      label: '银行卡',
      type: 'primary'
    },
    {
      value: 1,
      label: '钱包',
      type: 'success'
    },
    {
      value: 3,
      label: '承兑',
      type: 'warning'
    }
  ],
})

// mutations
const mutations = {
  SET_VEHICLETYPELIST: (state, vehicleTypeList) => {
    state.vehicleTypeList = vehicleTypeList
  }
}
// actions
const actions = {
  getVehicleTypeList({ commit, state }) {
    return new Promise((resolve, reject) => {
      getVehicleTypeList({ count: 10000 }).then(response => {
        const { data } = response
        if (data && data.list.length > 0) {
          commit('SET_VEHICLETYPELIST', data.list)
        }
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  }
}
const getters = {
  // 准驾车型
  driverClassList: state => {
    return state.driverClassList
  },
  // 散货单货物类型
  cargoTypeClass: state => {
    return state.cargoTypeClass
  },
  // 车辆类型
  vehicleTypeList: state => {
    return state.vehicleTypeList
  },
  // 车辆审核状态
  vehicleStateList: state => {
    return state.vehicleStateList
  },
  // 车辆长度
  vehicleLengthList: state => {
    return state.vehicleLengthList
  },
  // 牌照类型
  vehicleLicenceTypeList: state => {
    return state.vehicleLicenceTypeList
  },
  // 能源类型
  vehicleEnergyTypeList: state => {
    return state.vehicleEnergyTypeList
  },
  // 车辆重量
  vehicleWeightList: state => {
    const vehicleEnergyTypeList = []
    for (let i = 1; i <= 55; i++) {
      const item = i * 1000
      vehicleEnergyTypeList.push({
        value: item,
        label: item + 'KG'
      })
    }
    return vehicleEnergyTypeList
  },
  // 运单价格单位
  cargoPriceUnit: state => {
    return state.cargoPriceUnit
  },
  // 计划单状态
  planStatus: state => {
    return state.planStatus
  },
  // 计划单匹配状态
  matchStatusList: state => {
    return state.matchStatusList
  },
  // 订单状态
  orderStatusList: state => {
    return state.orderStatusList
  },
  payChannelList: state => {
    return state.payChannelList
  },
}
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/module/waybill.js